import CustomStore from 'devextreme/data/custom_store'
import store from '@/store/index.js'
import { isEmpty, cloneDeep } from 'lodash'
import { highlightingAttributesList } from '@/components/recherche/rechercheSearch/variables.js'
const highlightingAttributes = highlightingAttributesList

const operationMap = {
  '=': 'eq',
  '<>': 'neq',
  '<': 'lt',
  '>': 'gt',
  '<=': 'lte',
  '>=': 'gte',
  '<==>': 'TODO Between',
  contains: 'contains',
  notcontains: 'ncontains',
  startswith: 'startsWith',
  endswith: 'endswith'
}

const negatedOperationMap = {
  or: 'and',
  '=': '<>',
  contains: 'ncontains'
}

const operators = ['and', 'or']

const isNotEmpty = (value) => {
  return value !== undefined && value !== null && value !== ''
}

const handleSort = ({ selector, desc }) => {
  const splittedSelector = selector.split('.')
  return splittedSelector.reverse().reduce((res, key) => ({ [key]: res }), desc ? 'DESC' : 'ASC')
}

const getInitialOperator = (filter) => {
  const filtered = filter.filter(item => operators.includes(item))
  return filtered[0]
}

const generateFilterObject = (filterArray) => {
  const [fieldName, operation, filterValue] = filterArray
  const splittedFieldName = fieldName.split('.')
  const mappedOperation = operationMap[operation]
  const filterObject = splittedFieldName.reverse().reduce((res, key) => ({ [key]: res }), {
    [mappedOperation]: filterValue
  })
  return filterObject
}

const negateFilterStatement = (filterArray) => {
  for (let i = 0; i < filterArray.length; i++) {
   const element = filterArray[i]

   if (negatedOperationMap[element]) {
    filterArray[i] = negatedOperationMap[element]
   }

   if (Array.isArray(element)) {
     negateFilterStatement(filterArray[i])
   }
 }
 return filterArray
}

const traverseFilter = (filter, operator = 'and') => {
  const result = {
    and: [],
    or: []
  }

  for (let i = 0; i < filter.length; i++) {
    const item = filter[i]

    if (operators.includes(item)) {
      operator = item
    }

    if (Array.isArray(item)) {
      if (Array.isArray(item[0])) {
        const convertedFilter = traverseFilter(item, getInitialOperator(item))
        result[operator].push(convertedFilter)
      } else if (item[0] === ('!')) {
        const filterCopy = cloneDeep(item[1])
        const negatedFilter = negateFilterStatement([filterCopy])
        const convertedFilter = traverseFilter(negatedFilter, getInitialOperator(item))
        result[operator].push(convertedFilter)
      } else {
        const generatedFilterObject = generateFilterObject(item)
        result[operator].push(generatedFilterObject)
      }
    }
  }

  if (isEmpty(result.or)) {
    delete result.or
  }

  if (isEmpty(result.and)) {
    delete result.and
  }

  return result
}

export const createCustomStore = ({ key, self, methodName }) => {
  return new CustomStore({
    key,
    load: async (loadOptions) => {
      const gqlOptions = {
        where: {},
        order: {},
        take: null,
        skip: null
      }
      const actions = [ // eslint-disable-line
        'skip',
        'take',
        'requireTotalCount',
        /*
        'requireGroupCount',
        */
        'sort',
        'filter'
        /*
        'totalSummary',
        'group',
        'groupSummary'
        */
      ].forEach((action) => {
        if (action in loadOptions && isNotEmpty(loadOptions[action])) {
          if (action === 'skip') {
            gqlOptions.skip = loadOptions[action]
          } else if (action === 'take') {
            gqlOptions.take = loadOptions[action]
          } else if (action === 'sort') {
            const orderObject = handleSort(loadOptions[action][0])
            gqlOptions.order = orderObject
          } else if (action === 'filter') {
            const filterObject = traverseFilter([loadOptions[action]], getInitialOperator(loadOptions[action]))
            gqlOptions.where = filterObject
          }
        }
        if (!loadOptions.skip && !loadOptions.take) {
          gqlOptions.skip = 0
          gqlOptions.take = store.state.fundings.exportTotalCount
        }
      })

      const response = await self[methodName](gqlOptions)
      return response
    },
    update: (key, values) => {
    }
  })
}

// const handleFilter = (filterArray) => {
//   const generateFilterObject = (filterArray) => {
//     const [fieldName, operation, filterValue] = filterArray
//     const splittedFieldName = fieldName.split('.')
//     const mappedOperation = operationMap[operation]
//     return splittedFieldName.reverse().reduce((res, key) => ({ [key]: res }), {
//       [mappedOperation]: filterValue
//     })
//   }

//   let firstOperator = null
//   const arrayOfFilters = []
//   let secondOperator = null
//   let arrayOfSubFilters = []

//   if (Array.isArray(filterArray[0])) {
//     firstOperator = filterArray.find(element => element === 'and' || element === 'or')
//     filterArray.forEach(element => {
//       if (Array.isArray(element)) {
//         if (Array.isArray(element[0])) {
//           secondOperator = element.find(el => el === 'and' || el === 'or')
//           element.forEach(el => {
//             if (typeof el !== 'string') {
//               const filterObject = generateFilterObject(el)
//               arrayOfSubFilters.push(filterObject)
//             }
//           })
//           arrayOfFilters.push({ [secondOperator]: arrayOfSubFilters })
//           secondOperator = null
//           arrayOfSubFilters = []
//         } else if (typeof element !== 'string') {
//           const filterObject = generateFilterObject(element)
//           arrayOfFilters.push(filterObject)
//         }
//       }
//     })
//     return { [firstOperator]: arrayOfFilters }
//   } else {
//     return generateFilterObject(filterArray)
//   }

//   /* if (Array.isArray(filterArray[0])) {
//     // For combined filters
//     let tempFilter = {}
//     let latestOperator = ''

//     filterArray.forEach(element => {
//       if (Array.isArray(element)) {
//         const filterObject = generateFilterObject(element)

//         if (!latestOperator) {
//           tempFilter = { ...tempFilter, ...filterObject }
//         } else {
//           const operationObject = { [latestOperator]: filterObject }
//           tempFilter = { ...tempFilter, ...operationObject }
//         }
//         latestOperator = ''
//       } else if (typeof element === 'string') {
//         // set latest operation string
//         latestOperator = element
//       }
//     })
//   }
//     return tempFilter
//   }
//   // For single filter
//   return generateFilterObject(filterArray) */
// }

// const gqlOptions = {
//   order: {},
//   take: 0,
//   skip: 0
// }

// custom store devexpress version 21
// export const createCustomStore = ({ key, self, methodName }) => {
//   return new CustomStore({
//     key,
//     load: async (loadOptions) => {
//       [
//         'skip',
//         'take',
//         'requireTotalCount',
//         /*
//         'requireGroupCount',
//         */
//         'sort',
//         'filter'
//         /*
//         'totalSummary',
//         'group',
//         'groupSummary'
//         */
//       ].forEach((action) => {
//         delete gqlOptions.where // Reset for headerFilter
//         if (action in loadOptions && isNotEmpty(loadOptions[action])) {
//           if (action === 'skip') {
//             gqlOptions.skip = loadOptions[action]
//           } else if (action === 'take') {
//             gqlOptions.take = loadOptions[action]
//           } else if (action === 'sort') {
//             const orderObject = handleSort(loadOptions[action][0])
//             gqlOptions.order = orderObject
//           } else if (action === 'filter') {
//             const filterObject = handleFilter(loadOptions[action])
//             gqlOptions.where = filterObject
//           }
//         }
//         if (!loadOptions.skip && !loadOptions.take) {
//           gqlOptions.skip = 0
//           gqlOptions.take = store.state.fundings.exportTotalCount
//         }
//       })
//       const response = await self[methodName](gqlOptions)
//       return response
//     },
//     update: (key, values) => {
//     }
//   })
// }

export const createMeiliSearchCustomStore = ({ key }) => {
  return new CustomStore({
    key,
    load: async (loadOptions) => {
      [
        'skip',
        'take',
        'requireTotalCount',
        'sort',
        'filter',
        'userData',
        'isLoadingAll'
      ].forEach((action) => {
        if (action in loadOptions && isNotEmpty(loadOptions[action])) {
          JSON.stringify(loadOptions[action])
        }
        if (loadOptions.isLoadingAll) {
          loadOptions.take = store.getters['recherche/TOTALCOUNT_MS']
          loadOptions.skip = 0
        }
        if (loadOptions.sort !== null) {
          const msSort = [`${loadOptions.sort[0].selector.replace('_formatted.', '')}:${loadOptions.sort[0].desc === false ? 'asc' : 'desc'}`]
          if (loadOptions.isLoadingAll) {
            loadOptions.exportSort = msSort
          } else {
            loadOptions.userData.sort = msSort
          }
        } else {
          if (!loadOptions.isLoadingAll) {
            loadOptions.userData.sort = null
            loadOptions.exportSort = null
          } else {
            loadOptions.exportSort = null
          }
        }
        if (loadOptions && loadOptions.filter) {
            let customFilterElement = ''
            const filterArr = loadOptions.filter
            for (const filter in filterArr) {
              if (filter !== 'columnIndex' && filter !== 'filterValue') {
                if (typeof filterArr[filter] !== 'object') {
                    customFilterElement += filterArr[filter] === 'and' ? 'AND' + ' ' : filterArr[filter].toString().split(' ').length <= 1
                    ? filterArr[filter].toString().replace('_formatted.', '') + ' '
                    : "'" + filterArr[filter].toString().replace('_formatted.', '') + "'" + ' '
                } else {
                  for (const innerFilter in filterArr[filter]) {
                    if (innerFilter !== 'columnIndex' && innerFilter !== 'filterValue') {
                      customFilterElement += filterArr[filter][innerFilter] === 'and' ? 'AND' + ' ' : filterArr[filter][innerFilter].toString().split(' ').length <= 1
                      ? filterArr[filter][innerFilter].toString().replace('_formatted.', '') + ' '
                      : "'" + filterArr[filter][innerFilter].toString().replace('_formatted.', '') + "'" + ' '
                    }
                  }
                }
              }
            }
            // console.log('test Filter Arr', customFilterElement)
            customFilterElement = customFilterElement.replaceAll('<>', '!=')
            if (!loadOptions.isLoadingAll) {
              loadOptions.userData.filter = customFilterElement.trimEnd()
              if (store.getters['recherche/COMPLETE_CUSTOM_FILTER']) {
                loadOptions.userData.filter += ` AND ${store.getters['recherche/COMPLETE_CUSTOM_FILTER']}`
              }
            } else {
              loadOptions.exportFilter = customFilterElement.trimEnd()
              if (store.getters['recherche/COMPLETE_CUSTOM_FILTER']) {
                loadOptions.exportFilter += ` AND ${store.getters['recherche/COMPLETE_CUSTOM_FILTER']}`
              }
            }
        } else {
            if (!loadOptions.isLoadingAll) {
              loadOptions.userData.filter = store.getters['recherche/COMPLETE_CUSTOM_FILTER'] !== null ? `${store.getters['recherche/COMPLETE_CUSTOM_FILTER']}` : undefined
              loadOptions.exportFilter = store.getters['recherche/COMPLETE_CUSTOM_FILTER'] !== null ? `${store.getters['recherche/COMPLETE_CUSTOM_FILTER']}` : undefined
            } else {
              loadOptions.exportFilter = store.getters['recherche/COMPLETE_CUSTOM_FILTER'] !== null ? `${store.getters['recherche/COMPLETE_CUSTOM_FILTER']}` : undefined
            }
        }
      })
      return fetch(`https://app-meilisearch-prod-001.azurewebsites.net/indexes/${process.env.VUE_APP_MEILISEARCH_INDEX}/search`,
                   {
                     method: 'POST',
                     headers: { // ebe3dfac-c331-4c27-9b39-7e977e4803b5
                       'Content-Type': 'application/json',
                       Authorization: `Bearer ${process.env.VUE_APP_MEILISEARCH_TOKEN}`
                     },
                     body: JSON.stringify({
                       q: store.getters['recherche/SEARCHPARAM_MS'],
                       attributesToHighlight: highlightingAttributes,
                       limit: store.getters['recherche/SAVE_LIST_MAX_LIMIT'] === null ? loadOptions.take : store.getters['recherche/SAVE_LIST_MAX_LIMIT'],
                       offset: loadOptions.skip,
                       sort: loadOptions.userData !== undefined && loadOptions.isLoadingAll === undefined ? loadOptions.userData.sort : loadOptions.exportSort,
                       filter: loadOptions.userData !== undefined && loadOptions.isLoadingAll === undefined ? loadOptions.userData.filter : loadOptions.exportFilter
                     })
                   })
        .then(response => response.json())
        .then((data) => {
          // console.log('data ---->', data)
          for (const el in data.hits) {
            data.hits[el].sourceSavedList = false
            data.hits[el].sourceSearchList = true
          }
          if (store.getters['recherche/SAVE_LIST_MAX_LIMIT'] !== null) {
            store.commit('recherche/SET_LAST_ADDED_POOLDATA', data.hits)
            store.commit('recherche/SET_LAST_LIST_ADDED_STATUS', true)
            store.commit('recherche/SET_SAVE_LIST_MAX_LIMIT', null)
          }
          return {
            data: data.hits,
            totalCount: data.estimatedTotalHits
          }
        })
        .catch((err) => { throw err })
    }
  })
}
